export const LOAD_STAFF_DETAIL = 'staff/LOAD_STAFF_DETAIL';
export const LOAD_STAFF_DETAIL_SUCCESS = 'staff/LOAD_STAFF_DETAIL_SUCCESS';
export const LOAD_STAFF_DETAIL_ERROR = 'staff/LOAD_STAFF_DETAIL_ERROR';

export const CREATE_STAFF = 'staff/CREATE_STAFF';
export const CREATE_STAFF_SUCCESS = 'staff/CREATE_STAFF_SUCCESS';
export const CREATE_STAFF_ERROR = 'staff/CREATE_STAFF_ERROR';

export const UPDATE_STAFF = 'staff/UPDATE_STAFF';
export const UPDATE_STAFF_SUCCESS = 'staff/UPDATE_STAFF_SUCCESS';
export const UPDATE_STAFF_ERROR = 'staff/UPDATE_STAFF_ERROR';
